import axios from "axios";
import { domain } from "../Links/Links";

export async function WalletRequest(
  setTokensInfo,
  setRequestStatus,
  setInactiveWalletMessage,
) {
  const respnse = await axios.get(domain + "/wallet_api/", {
    withCredentials: true,
  });

  if (respnse.data) {

    setTokensInfo(respnse.data);

    setRequestStatus(false);

    // if (respnse.data.inactive_wallet_message) {
    //   setInactiveWalletMessage(respnse.data.inactive_wallet_message);
    // }
    
  }
}
